import EFOcats_logic from '../efocats_logic.js';

/**
 * イベントクラス
 */
export default class EFOcats_event_core extends EFOcats_logic {
  /**
   * イベントための事前の仕込み
   */
  init() {
    // 子クラスで実装する
  }

  /**
   * イベント本体をセット
   */
  event() {
    // 子クラスで実装する
  }

  /**
   * 郵便番号の置換
   * @param elem
   */
  rep_yubin(elem) {
    let material_val = elem.val();
    material_val = material_val.replace(/-/g, '');
    material_val = material_val.replace(/-/g, '');
    material_val = material_val.replace(/ー/g, '');
    material_val = material_val.replace(/ー/g, '');
    material_val = material_val.replace(/‐/g, '');
    material_val = material_val.replace(/‑/g, '');
    material_val = material_val.replace(/–/g, '');
    material_val = material_val.replace(/—/g, '');
    material_val = material_val.replace(/―/g, '');
    material_val = material_val.replace(/−/g, '');
    material_val = material_val.replace(/ｰ/g, '');
    material_val = material_val.replace(/[０-９]/g, s => {
      return String.fromCharCode(s.charCodeAt(0) - 65248);
    });
    elem.val(material_val);
  }
}
